const features = {
  nodaFiCheck: 'nodafi_check',
  survey: 'survey',
  externalOrganizations: 'external_organizations',
  insight: 'insight',
  procedures: 'procedures',
  purchaseOrders: 'purchase_orders',
  procedureFieldEntryComments: 'procedure_field_entry_comments',
  customViews: 'custom_views',
  issueCategoryHierarchy: 'issue_category_hierarchy',
  duplicatePmsConfig: 'duplicate_pms_config',
  advancedInsights: 'advanced_insights',
  duplicateLocationConfig: 'duplicate_location_config',
  goldenBroom: 'golden_broom',
  aiReports: 'ai_reports',
  archivedTickets: 'archived_tickets',
} as const

export type FeatureGateName = (typeof features)[keyof typeof features]

export default features
